<template>
    <div v-if="tableViewsByType(type) && tableViewsByType(type).length" class="columns is-desktop toolbar-box">
        <div class="column is-4-tablet is-2-desktop"></div>
        <div class="column is-4-tablet is-2-desktop">
            <o-field>
                <o-select
                        v-model="viewId"
                        :expanded="true"
                        placeholder="Select a Custom View"
                        @update:modelValue="viewId = $event; handleUpdate($event)"
                >
                    <option value="">Select a Custom View</option>
                    <option
                            v-for="view in tableViewsByType(type)"
                            :value="view.id"
                            :key="view.id"
                    >
                        {{ view.name }}
                    </option>
                </o-select>
            </o-field>
        </div>
        <slot name="siblings" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        props: ['type', 'viewIdProp', "handleUpdate"],

        data () {
            return {
                viewId: this.viewIdProp
            }
        },

        computed: {
            ...mapGetters(['tableViewsByType'])
        },

        watch: {
            viewIdProp (value) {
                this.viewId = value
            }
        }
    }
</script>
